var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupervisorAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 15q-1.05 0-1.775-.725T14.5 12.5t.725-1.775T17 10t1.775.725.725 1.775-.725 1.775T17 15m-5 4v-.4q0-.6.313-1.113a1.76 1.76 0 0 1 .887-.737q.9-.375 1.863-.562a10.1 10.1 0 0 1 3.874 0 9.6 9.6 0 0 1 1.863.562q.575.225.887.738Q22 18 22 18.6v.4q0 .424-.288.712A.97.97 0 0 1 21 20h-8a.97.97 0 0 1-.713-.288A.97.97 0 0 1 12 19m-2-7q-1.65 0-2.825-1.175T6 8t1.175-2.825T10 4t2.825 1.175T14 8t-1.175 2.825T10 12m-8 5.2q0-.85.425-1.562A2.8 2.8 0 0 1 3.6 14.55q1.5-.75 3.113-1.15Q8.324 13 10 13q.875 0 1.75.15t1.75.35l-.85.85-.85.85a5 5 0 0 0-.9-.162Q10.45 15 10 15q-1.45 0-2.838.35-1.387.35-2.662 1a.85.85 0 0 0-.375.35Q4 16.925 4 17.2v.8h6v.975q0 .325.125.587.125.263.35.438H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18zm8-7.2q.825 0 1.412-.588Q12 8.826 12 8q0-.824-.588-1.412A1.93 1.93 0 0 0 10 6q-.825 0-1.412.588A1.93 1.93 0 0 0 8 8q0 .825.588 1.412Q9.175 10 10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupervisorAccount);
export default __webpack_public_path__ + "static/media/supervisor_account.ef1438e7ff1b5f2556e18f696999e917.svg";
export { ForwardRef as ReactComponent };